import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from "react-router-dom";
import storePersist from "../../redux/storePersist";
import { getCardData } from "../../common/services/website-card.service";


const TestimonialPage = () => {
    const navigate = useNavigate();
    const image1 = require("../../assets/img/image 1.png");
    const image2 = require("../../assets/img/default community.jpg");

    const handleSupport = async () => {
        await navigate('customer/support')
    }

    


    return (
        <>
            {/* 🔽 Testimonial Section 🔽 */}
            <div className="bg-white py-20 px-4">
                <h2 className="text-3xl font-bold text-center mb-12 text-primary">
                    <span className="text-primary">Testimonials </span>
                   
                </h2>

                <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6">
                    {/* Testimonial Card 1 */}
                    <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                        <div className="mb-4">
                            <img src={image2} alt="Nitro" className="h-6 mb-2" />
                            <p className="text-gray-800 italic text-sm">
                                “Kissmetrics provided us the ability to track unique events and segment who the users are and what each user is doing. Google Analytics doesn’t allow that.”
                            </p>
                        </div>
                        <div className="flex items-center gap-4 mt-4">
                            <img src={image2} alt="Alex" className="h-10 w-10 rounded-full" />
                            <div>
                                <p className="font-semibold text-sm">Alex Acker</p>
                                <p className="text-xs text-gray-500">Senior Manager, Marketing & Insights</p>
                            </div>
                        </div>
                    </div>

                    {/* Testimonial Card 2 */}
                    <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                        <div className="mb-4">
                            <img src={image2} alt="PagerDuty" className="h-6 mb-2" />
                            <p className="text-gray-800 italic text-sm">
                                “We saw a 25% boost in trial engagement using Kissmetrics’ Cohort Reports. New users were actively using the product earlier in their trial.”
                            </p>
                        </div>
                        <div className="flex items-center gap-4 mt-4">
                            <img src={image2} alt="David" className="h-10 w-10 rounded-full" />
                            <div>
                                <p className="font-semibold text-sm">David Shackelford</p>
                                <p className="text-xs text-gray-500">Project Manager</p>
                            </div>
                        </div>
                    </div>

                    {/* Testimonial Card 3 */}
                    <div className="bg-gray-100 p-6 rounded-lg shadow-md">
                        <div className="mb-4">
                            <img src={image2} alt="Lucidchart" className="h-6 mb-2" />
                            <p className="text-gray-800 italic text-sm">
                                “Insights from Kissmetrics drove a 30% lift in our conversions. We can quickly identify and act on any roadblocks across our growth cycle.”
                            </p>
                        </div>
                        <div className="flex items-center gap-4 mt-4">
                            <img src={image2} alt="Spencer" className="h-10 w-10 rounded-full" />
                            <div>
                                <p className="font-semibold text-sm">Spencer Mann</p>
                                <p className="text-xs text-gray-500">VP of Growth</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    );
};

export default TestimonialPage;
